// packages/shared/src/rules/house.ts
import { tuning, type HouseLevel } from '@whiskerton/content';
import type { TileXY } from '../types/geom';
import type { RejectCode } from '../protocol/codes';
import { nextLocalTime } from '../time';

export function upgradeCost(toLevel: HouseLevel): number { return tuning.house.levels[toLevel].cost; }

export function roomsForLevel(level: HouseLevel): { w: number; h: number; door: TileXY; exits: { at: TileXY; toRoom: number | 'out' }[] }[] {
  const rooms = tuning.house.levels[level].rooms as readonly (readonly [number, number])[];
  const [w0, h0] = rooms[0]!;
  return rooms.map(([w, h], i) => {
    const door = { x: Math.floor(w / 2), y: h - 1 };
    const exits: { at: TileXY; toRoom: number | 'out' }[] = i === 0
      ? [{ at: door, toRoom: 'out' }, ...rooms.slice(1).map((_, j) => ({
          at: j === 0 ? { x: Math.floor(w0 / 2), y: 0 } : { x: 0, y: Math.floor(h0 / 2) }, toRoom: j + 1 }))]
      : [{ at: door, toRoom: 0 }];
    return { w, h, door, exits };
  });
}

export function applyPayment(s: { loan: number; bells: number }, amount: number): { loan: number; bells: number; paidOff: boolean } | RejectCode {
  if (s.loan <= 0) return 'no_loan';
  if (!Number.isInteger(amount) || amount <= 0 || amount > s.loan) return 'bad_amount';
  if (amount > s.bells) return 'not_enough_bells';
  const loan = s.loan - amount;
  return { loan, bells: s.bells - amount, paidOff: loan === 0 };
}

export function nextConstructionAt(now: number, timeZone: string): number {
  return nextLocalTime(now, timeZone, tuning.time.constructionHour, 0);
}
